import React, { useEffect, useRef, useState } from "react";
import AdminLoader from "../../../../../components/common/loader/AdminLoader";
import { MdSearch } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import AssignShowTasks from "./AssignShowTasks";
import {
  fetchWorkEntries,
  fetchWorkEntriesProjectTracking,
} from "../../../../../store/slices/workentriesSlice";
import {
  fetchDescriptionTasks,
  fetchDescriptionTasksProjectTracking,
} from "../../../../../store/slices/DescriptionTask";
import {
  fetchHardwareDescriptions,
  fetchHardwareProjectTracking,
} from "../../../../../store/slices/hardwareDescriptionSlice";
import { fetchEmployees } from "../../../../../store/slices/employeeSlice";
import { fetchAllProjects } from "../../../../../store/slices/projectsSlice";
import FileUploadSales from "../ResponseReceived/FileUploadSales";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useCurrencySymbol } from "../../../../../utils/currencyUtils";
import DateConversion from "../../../../../utils/DateConversion";
import { fetchLeads } from "../../../../../store/slices/leadsSlice";
import { fetchGroups } from "../../../../../store/slices/groupSlice";
import { getMyTrainings } from "../../../../../store/slices/MyTraining/myTrainings";

const ProjectAssignSales = ({
  salesAssignedGroupProject,
  handlerefresh,
  isViewOnly = false,
}) => {
  const dispatch = useDispatch();
  const { formatDateByCountry } = DateConversion();
  const currency = useCurrencySymbol();
  const { employees } = useSelector((state) => state.employees);
  const { projects } = useSelector((state) => state.projects);
  const { group: masterGroups } = useSelector((state) => state.group);

  const { entries } = useSelector((state) => state.workentries);
  const { items } = useSelector((state) => state.hardwareDescription);
  const { tasks } = useSelector((state) => state.descriptionTasks);
  const [rowName, setRowName] = useState(null)
  const { leads } = useSelector((state) => state.leads);

  const { projectTrackingWorkEntries } = useSelector(
    (state) => state.workentries
  );
  const { hardwareProjectTracking } = useSelector(
    (state) => state.hardwareDescription
  );
  const { descriptionProjectTracking } = useSelector(
    (state) => state.descriptionTasks
  );

  useEffect(() => {
    dispatch(fetchLeads());
    dispatch(fetchWorkEntriesProjectTracking());
    dispatch(fetchDescriptionTasksProjectTracking());
    dispatch(fetchHardwareProjectTracking());
    dispatch(fetchWorkEntries());
    dispatch(fetchHardwareDescriptions());
    dispatch(fetchDescriptionTasks());
    dispatch(fetchEmployees());
    dispatch(fetchAllProjects());
    dispatch(fetchGroups());
    dispatch(getMyTrainings());
  }, [dispatch]);

  const [currentProject, setCurrentProject] = useState(null);
  const [showAttach, setShowAttach] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [openInputReceived, setOpenInputReceived] = useState(null);

  const [selected, setSelected] = useState(false);
  const responseassignref = useRef(null);
  useEffect(() => {
    if ((rowName)) {
      // Scroll to the right end of the container
      const scrollToPosition = responseassignref.current.scrollWidth;
      responseassignref.current.scrollTo({
        left: scrollToPosition,
        behavior: 'smooth'
      });
    }
  }, [rowName]);
  const dropdownRefOpenInput = useRef([]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        openInputReceived !== null &&
        dropdownRefOpenInput.current[openInputReceived] &&
        !dropdownRefOpenInput.current[openInputReceived].contains(event.target)
      ) {
        setOpenInputReceived(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openInputReceived]);

  const [sortedProjects, setSortedProjects] = useState([]);
  const resolveId = (value) => {
    if (!value) return "";
    if (typeof value === "string" || typeof value === "number") {
      return String(value).trim();
    }
    return String(value?._id || value?.id || "").trim();
  };

  const getGroupDisplayName = (row) => {
    const groupId =
      resolveId(row?.projectdata?.groupid) ||
      resolveId(row?.groupid) ||
      resolveId(row?.lead?.groupid);

    if (!groupId) return "";

    const matchedGroup = (masterGroups || []).find(
      (group) => resolveId(group?._id) === groupId
    );

    return (
      matchedGroup?.newGroupName ||
      matchedGroup?.GroupName ||
      matchedGroup?.groupName ||
      matchedGroup?.name ||
      ""
    );
  };

  const getRowKey = (row) =>
    row?.quotationId != null && String(row.quotationId).trim() !== ""
      ? String(row.quotationId).trim()
      : row?.ProjectName ?? "";

  useEffect(() => {
    setSortedProjects(salesAssignedGroupProject);
  }, [salesAssignedGroupProject]);

  const itemsPerPage = 10; // or any number of rows you want per page
  const [currentPage, setCurrentPage] = useState(1);

  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchInputChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    setCurrentPage(1);
    filterLeadReports(query)
  };

  const totalItems = sortedProjects.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const startIdx = (currentPage - 1) * itemsPerPage;
  const endIdx = startIdx + itemsPerPage;
  const paginatedProjects = sortedProjects.slice(startIdx, endIdx);

    const filterLeadReports = (query) => {
    const lowerCaseQuery = query.toLowerCase().trim();

    const filtered = salesAssignedGroupProject.filter((LeadReport) =>
      Object.entries(LeadReport).some(([key, value]) => {
        // Skip these keys
        if (
          key === "Assignedperson" ||
          key === "TypeService" ||
          key === "SalesPersonName" ||
          key === "SalesPersonEmail" ||
          key === "ResourceType" ||
          key === "QuotedValue" ||
          key === "ProjectManagerStatus" ||
          key === "ProjectManagerAction" ||
          key === "createdAt" ||
          key === "updatedAt" ||
          key === "PrimaryResources"
        )
          return false;

        if (value === null || value === undefined) return false;
        if (key === "DateRequested" || key === "ProjectDueDate") {
          const formattedDate = formatDateByCountry(value);  // ← change here
          return formattedDate.toLowerCase().includes(lowerCaseQuery);
        }
        if (key === "AssignedGroup" || key === "groupid") {
          const groupName = getGroupDisplayName(LeadReport).toLowerCase();
          return groupName.includes(lowerCaseQuery);
        }
        // Handle all other fields
        const formattedValue = value.toString().trim().toLowerCase();
        return formattedValue.includes(lowerCaseQuery);
      })
    );

    setSortedProjects(filtered);
  };

  const sortAlphabetically = (targetToSort, order) => {
    const key = `${targetToSort}-${order}`;
    let sorted = [...sortedProjects]; // Always sort from the filtered dataset

    const compareStrings = (a, b) => {
      const valA = (a || "").toString().toLowerCase();
      const valB = (b || "").toString().toLowerCase();
      return valA.localeCompare(valB);
    };
    // Helper function for date comparison
    const compareDates = (a, b) => {
      const dateA = a ? new Date(a) : null;
      const dateB = b ? new Date(b) : null;

      if (!dateA && !dateB) return 0;
      if (!dateA) return 1;
      if (!dateB) return -1;

      return dateA - dateB;
    };

    switch (key) {
      case "AssignedGroup-az":
        sorted.sort((a, b) =>
          compareStrings(getGroupDisplayName(a), getGroupDisplayName(b))
        );
        break;
      case "AssignedGroup-za":
        sorted.sort((a, b) =>
          compareStrings(getGroupDisplayName(b), getGroupDisplayName(a))
        );
        break;
      case "ProjectName-az":
        sorted.sort((a, b) => compareStrings(a.ProjectName, b.ProjectName));
        break;
      case "ProjectName-za":
        sorted.sort((a, b) => compareStrings(b.ProjectName, a.ProjectName));
        break;
      case "DateRequested-az":
        sorted.sort((a, b) => compareDates(a.DateRequested, b.DateRequested));
        break;
      case "DateRequested-za":
        sorted.sort((a, b) => compareDates(b.DateRequested, a.DateRequested));
        break;
      case "ProjectDueDate-az":
        sorted.sort((a, b) => compareDates(a.ProjectDueDate, b.ProjectDueDate));
        break;
      case "ProjectDueDate-za":
        sorted.sort((a, b) => compareDates(b.ProjectDueDate, a.ProjectDueDate));
        break;
      default:
        // Default to original filtered order
        sorted = [...sortedProjects];
        break;
    }

    setSortedProjects(sorted);
    setCurrentPage(1); // Reset to first page after sorting
  };

  return (
    <div>
      <>
        <div className="pt-2">
          {isLoading ? <AdminLoader isLoading={isLoading} /> : <></>}

          <>
            <div className="w-full bg-white flex justify-between items-center p-2">
              <div className="font-semibold ">
                <h3>Project Assigned</h3>

              </div>
              <div className="flex gap-2 p-1 align-middle items-center bg-[#e0e7ff] rounded-full">
                <MdSearch className=" w-5 h-5 text-gray-500" />
                <input
                  type="text"
                  value={searchQuery}
                  onChange={handleSearchInputChange}
                  placeholder="Search"
                  className="bg-[#e0e7ff] outline-none w-[80%]"
                />
              </div>
            </div>
            <div ref={responseassignref} className="w-full bg-white h-full  min-h-[15rem] max-h-[90vh] overflow-auto pb-12">
              <div className="sticky top-0 z-[1299] bg-[#e8e8e8]">
                <div className="flex w-full  text-xs  text-center font-semibold">
                  <div className={` flex ${rowName ? "" : "w-[80%]"} h-12`}>
                    <div className="w-12 bg-[#e8e8e8]  flex justify-center items-center">Sr. No</div>
                    <div className={` ${rowName ? "w-28" : "w-[20%]"} bg-[#e8e8e8] relative p-2 break-words text-wrap flex justify-start items-center align-middle `} >
                      Group
                      <div className="flex flex-col absolute right-1">
                        <div
                          className="cursor-pointer "
                          onClick={() =>
                            sortAlphabetically("AssignedGroup", "az")
                          }
                        >
                          <ArrowDropUp
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>

                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() =>
                            sortAlphabetically("AssignedGroup", "za")
                          }
                        >
                          <ArrowDropDown
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className={` ${rowName ? "w-28" : "w-[20%]"} bg-[#e8e8e8] relative p-2 break-words text-wrap flex justify-start items-center align-middle" `}>
                      Project
                      <div className="flex flex-col absolute right-1">
                        <div
                          className="cursor-pointer "
                          onClick={() =>
                            sortAlphabetically("ProjectName", "az")
                          }
                        >
                          <ArrowDropUp
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>

                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() =>
                            sortAlphabetically("ProjectName", "za")
                          }
                        >
                          <ArrowDropDown
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className={` ${rowName ? "w-36" : "w-[20%]"} bg-[#e8e8e8] relative  p-2 break-words text-wrap flex justify-around items-center align-middle `}>
                      Date  Requested{" "}
                      <div className="flex flex-col absolute right-1">
                        <div
                          className="cursor-pointer "
                          onClick={() =>
                            sortAlphabetically("DateRequested", "az")
                          }
                        >
                          <ArrowDropUp
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>

                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() =>
                            sortAlphabetically("DateRequested", "za")
                          }
                        >
                          <ArrowDropDown
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className={` ${rowName ? "w-28" : "w-[20%]"} bg-[#e8e8e8] relative  p-2 break-words text-wrap flex justify-around items-center align-middle `}>
                      Due Date
                      <div className=" flex flex-col absolute right-1">
                        <div
                          className="cursor-pointer "
                          onClick={() =>
                            sortAlphabetically("ProjectDueDate", "az")
                          }
                        >
                          <ArrowDropUp
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>

                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() =>
                            sortAlphabetically("ProjectDueDate", "za")
                          }
                        >
                          <ArrowDropDown
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className={` ${rowName ? "w-28" : "w-[20%]"} bg-[#e8e8e8]  p-2 break-words text-wrap flex justify-center items-center`} >
                      Attachment
                    </div>

                  </div>
                  {rowName ? (
                    <div className="flex  ">
                      <div className="flex">
                        <div className="w-36 bg-[#e8e8e8] flex justify-center items-center  break-words text-wrap">
                          Manager Details
                        </div>
                        <div className=" w-48 break-words text-wrap flex ">
                          <div className="w-[50%]   flex justify-center items-center">
                            Hours/Parts
                          </div>
                          <div className="w-[50%] flex justify-center items-center">
                            Expenses ({currency})
                          </div>
                        </div>
                      </div>

                      <div className="flex">
                        <div className="w-36 bg-[#e8e8e8]  break-words text-wrap flex justify-center items-center">
                          Employee Details
                        </div>
                        <div className="w-52 bg-[#e8e8e8]  break-words text-wrap flex">
                          <div className="w-[50%]  flex justify-center items-center">
                            Hours/Parts
                          </div>
                          <div className="w-[50%] flex justify-center items-center">
                            Expenses ({currency})
                          </div>
                        </div>
                      </div>

                      <div className="flex flex-col w-52 ">
                        <div className=" bg-[#e8e8e8] h-[50%]  break-words text-wrap flex justify-center items-center" >
                          Total
                        </div>
                        <div className=" bg-[#e8e8e8] h-[50%]  break-words text-wrap flex ">
                          <div className="w-[50%] e flex justify-center items-center">
                            Hours/Parts
                          </div>
                          <div className="w-[50%] flex justify-center items-center">
                            Expenses ({currency})
                          </div>
                        </div>
                      </div>

                      <div className="w-44 bg-[#e8e8e8] flex justify-center items-center  p-2 break-words text-wrap">
                        Action
                      </div>
                    </div>
                  ) : (
                      <div className=" w-[20%] flex justify-center bg-[#e8e8e8] items-center  ">
                      Task Details
                    </div>
                  )}
                </div>
              </div>

              <div className="w-full">
                {paginatedProjects.map((row, index) => {
                  const matchedRowWorkEntries =
                    projectTrackingWorkEntries.filter(
                      (entry) => entry.projectid === row._id
                    );

                  const matchedRowDesctiption =
                    descriptionProjectTracking.filter(
                      (entry) => entry.projectid === row._id
                    );

                  const rowKey = getRowKey(row);
                  return (
                    <div
                      className={`flex text-xs ${row.isRead === false ? "font-bold" : " "} w-full ursor-pointer group  cursor-pointer`}
                      key={rowKey || index}
                    >
                      <div className={` flex ${rowName ? "" : "w-[80%]"}`}>
                        <div onClick={() => {
                          setRowName(rowName === rowKey ? null : rowKey);
                          setSelected(!selected);
                        }}
                          className="w-12 p-2 text-start border-b flex justify-start align-middle items-center group-hover:bg-gray-100">
                          {startIdx + index + 1}
                        </div>
                        <div onClick={() => {
                          setRowName(rowName === rowKey ? null : rowKey);
                          setSelected(!selected);
                        }}
                          className={` ${rowName ? "w-28" : "w-[20%]"} border-b flex justify-start align-middle items-center group-hover:bg-gray-100 p-2 break-words text-wrap `}>
                          {getGroupDisplayName(row)}
                        </div>
                        <div onClick={() => {
                          setRowName(rowName === rowKey ? null : rowKey);
                          setSelected(!selected);
                        }}
                          className={` ${rowName ? "w-28" : "w-[20%]"} border-b flex justify-start align-middle items-center text-left p-2 break-words group-hover:bg-gray-100 whitespace-normal overflow-hidden text-ellipsis line-clamp-2 leading-snug text-xs`}>
                          {row.ProjectName}
                        </div>
                        <div onClick={() => {
                          setRowName(rowName === rowKey ? null : rowKey);
                          setSelected(!selected);
                        }}
                          className={` ${rowName ? "w-36" : "w-[20%]"} border-b flex justify-center align-middle items-center p-2 break-words text-wrap group-hover:bg-gray-100`}>
                          {row.DateRequested &&
                            !isNaN(new Date(row.DateRequested))
                            ? formatDateByCountry(row.DateRequested)
                            : " "}
                        </div>
                        <div onClick={() => {
                          setRowName(rowName === rowKey ? null : rowKey);
                          setSelected(!selected);
                        }}
                          className={` ${rowName ? "w-28" : "w-[20%]"} border-b flex justify-center align-middle items-center p-2 break-words text-wrap group-hover:bg-gray-100`}>
                          {row.ProjectDueDate &&
                            !isNaN(new Date(row.ProjectDueDate))
                            ? formatDateByCountry(row.ProjectDueDate)
                            : " "}
                        </div>
                        <div className={` ${rowName ? "w-28" : "w-[20%]"} border-b p-2 flex justify-center align-middle items-center text-center break-words text-wrap group-hover:bg-gray-100`}>
                          <AttachFileIcon
                            className="rotate-12 cursor-pointer"
                            onClick={() => {
                              setCurrentProject(row);
                              setShowAttach(true);
                            }}
                          />
                        </div>
                      </div>
                      {rowName === rowKey ? (
                        <>
                          <div className="projetdetails flex border-b">
                            <AssignShowTasks
                              row={row}
                              employees={employees}
                              index={index}
                              setIsLoading={setIsLoading}
                              matchedRowWorkEntries={matchedRowWorkEntries}
                              matchedRowDesctiption={matchedRowDesctiption}
                              projectTrackingWorkEntries={
                                projectTrackingWorkEntries
                              }
                              hardwareProjectTracking={hardwareProjectTracking}
                              descriptionProjectTracking={
                                descriptionProjectTracking
                              }
                              items={items}
                              entries={entries}
                              projects={projects}
                              tasks={tasks}
                              leads={leads}
                              handlerefresh={handlerefresh}
                              isViewOnly={isViewOnly}
                            />
                          </div>
                       </>
                      ) : (
                        <div
                          onClick={() => {
                            setRowName(rowName === rowKey ? null : rowKey);
                            setSelected(!selected);
                          }}
                          className={` ${rowName ? "" : "w-[20%]"} group-hover:bg-gray-100 cursor-pointer flex justify-center align-middle items-center border-b`}>
                          {rowName ? (
                            <div className=' flex'>
                              <div className="w-36 p-2"></div>
                              <div className="w-48 p-2"></div>
                              <div className="w-36 p-2"></div>
                              <div className="w-52 p-2 flex justify-center align-middle items-center">
                                Multiple
                              </div>
                              <div className="w-52  p-2"></div>
                              <div className="w-44 p-2"></div>
                            </div>
                          ) : (
                            <div className="border-none">
                              Multiple
                            </div>
                          )}
                        </div>
                      )
                      }
                    </div>
                  );
                })}
                {paginatedProjects.length === 0 && (
                  <div className="noDataAvailable p-2">No Result Found</div>
                )}
              </div>
            </div>
            <div
              className={`pagination flex justify-between  text-xs items-center bg-white pb-2 pl-2 rounded-md ${paginatedProjects.length > 0 ? "p-1" : ""
                } `}
            >
              <div>
                {totalItems > 0 ? (
                  <>
                    Showing {startIdx + 1} to {Math.min(endIdx, totalItems)} of{" "}
                    {totalItems} Entries
                  </>
                ) : (
                  <>
                    {paginatedProjects.length > 0 && (
                      <>Showing {paginatedProjects.length} Entries</>
                    )}
                  </>
                )}
              </div>

              {totalPages > 1 && (
                <div className="flex">
                  <button
                    onClick={() => setCurrentPage(1)}
                    className="px-2 py-2 mx-1 border rounded"
                    disabled={currentPage === 1}
                    title="First Page"
                  >
                    <KeyboardDoubleArrowLeftIcon className="w-5 h-5" />
                  </button>
                  <button
                    onClick={() =>
                      setCurrentPage((prev) => Math.max(prev - 1, 1))
                    }
                    className="px-2 py-2 mx-2 border rounded"
                    disabled={currentPage === 1}
                  >
                    <ChevronRightIcon className="w-5 h-5 rotate-180" />
                  </button>

                  {Array.from({ length: 3 }, (_, index) => {
                    const pageNumber = currentPage - 1 + index;
                    if (pageNumber >= 1 && pageNumber <= totalPages) {
                      return (
                        <button
                          key={pageNumber}
                          onClick={() => setCurrentPage(pageNumber)}
                          className={`px-4 py-2 mx-2 border rounded ${currentPage === pageNumber
                            ? "bg-gray-300"
                            : ""
                            }`}
                        >
                          {pageNumber}
                        </button>
                      );
                    }
                    return null;
                  })}

                  <button
                    onClick={() =>
                      setCurrentPage((prev) =>
                        Math.min(prev + 1, totalPages)
                      )
                    }
                    className="px-2 py-2 mx-2 border rounded"
                    disabled={currentPage === totalPages}
                  >
                    <ChevronRightIcon className="w-5 h-5" />
                  </button>

                  <button
                    onClick={() => setCurrentPage(totalPages)}
                    className="px-2 py-2 mx-1 border rounded"
                    disabled={currentPage === totalPages}
                    title="Last Page"
                  >
                    <KeyboardDoubleArrowRightIcon className="w-5 h-5" />
                  </button>
                </div>
              )}
            </div>
          </>
        </div>

        {showAttach && (
          <FileUploadSales
            currentProject={currentProject}
            setShowAttach={setShowAttach}
            employees={employees}
            isViewOnly={isViewOnly}
          />
        )}
      </>
    </div >
  );
};

export default ProjectAssignSales;
